import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { ArkUnitOfWork } from 'app/core/core.module';
import { DevExtremeModule } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-online-summary-dialog',
    templateUrl: './online-summary-dialog.component.html',
    styleUrls: ['./online-summary-dialog.component.scss'],
    imports: [CommonModule, DevExtremeModule],
    standalone: true,
})
export class OnlineSummaryDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    amounts: any;
    contributions: any;
    selectedMonth: number;
    cloverAccounts: any;
    month: string;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, public appInfo: AppInformationService) {}

    async ngOnInit() {
        console.log('contributions', this.contributions);
        this.month = moment()
            .month(this.selectedMonth - 1)
            .format('MMMM');
        this.cloverAccounts = await this.uow.getCloverAccounts();
        this.amounts.funds = [];
        this.amounts.lastMonthFunds = [];
        this.amounts.nextMonthFunds = [];
        this.amounts.accountTotals = [];
        this.getData();
        this.amounts.clover = this.amounts.currentMonth + this.amounts.nextMonth;
        this.amounts.bank = this.amounts.fee + this.amounts.currentMonth + this.amounts.lastMonth;
        this.amounts.qb = this.amounts.fee + this.amounts.currentMonth + this.amounts.nextMonth;
        this.amounts.benevolence = _.sum(
            this.contributions
                .filter((x) => {
                    return x.fund === 'Benevolence Fund' && !x.processed;
                })
                .map((x) => {
                    return x.grossGift;
                })
        );
    }

    async getData() {
        this.cloverAccounts.forEach((cloverAccount) => {
            const lastMonthAmount = _.sum(
                this.amounts.contributions.map((x) => {
                    if (x.fund === cloverAccount.cloverName && x.processed) return x.grossGift ?? 0;
                })
            );
            this.amounts.lastMonthFunds.push({ id: cloverAccount.id, name: cloverAccount.cloverName, accountId: cloverAccount.contributionAccountId, amount: lastMonthAmount });

            const amount = _.sum(
                this.amounts.contributions.map((x) => {
                    if (x.fund === cloverAccount.cloverName && !x.processed && x.bankTransactionId) return x.grossGift ?? 0;
                })
            );
            this.amounts.funds.push({ id: cloverAccount.id, name: cloverAccount.cloverName, accountId: cloverAccount.contributionAccountId, amount: amount });

            const nextMonthAmount =
                _.sum(
                    this.amounts.contributions.map((x) => {
                        if (x.fund === cloverAccount.cloverName && !x.processed && !x.bankTransactionId) return x.grossGift ?? 0;
                    })
                ) ?? 0;
            this.amounts.nextMonthFunds.push({ id: cloverAccount.id, name: cloverAccount.cloverName, accountId: cloverAccount.contributionAccountId, amount: nextMonthAmount });

            const accountTotal = _.sum(
                this.amounts.contributions.map((x) => {
                    if (x.fund === cloverAccount.cloverName && !x.processed) return x.grossGift ?? 0;
                })
            );
            this.amounts.accountTotals.push({ id: cloverAccount.id, name: cloverAccount.cloverName, accountId: cloverAccount.contributionAccountId, amount: accountTotal });
        });

        // const offeringsAM = this.amounts.contributions.map(x => {if (x.fund.indexOf('AM Offering') !== -1) return {grossGift: x.grossGift, date: x.donationDate}});
        // const offeringsPM = this.amounts.contributions.map(x => {if (x.fund.indexOf('PM Offering') !== -1) return {grossGift: x.grossGift, date: x.donationDate}});
        // console.log(offeringsAM);
        // console.log(offeringsPM);
        // offeringsAM.filter(x => {return !!x}).forEach(async offering => {
        //     const sunday = moment(offering.date).isoWeekday(6).add(1, 'days').startOf('day').toDate();
        //     console.log(sunday);
        //     const offeringScheduled = await this.uow.getOfferingsScheduledByDate(sunday, true, false) as any;
        //     console.log('offeringScheduled', offeringScheduled)
        //     this.amounts.funds.push({id: offeringScheduled.id, name: offeringScheduled.specialAccount.name, accountId: offeringScheduled.specialAccountId, amount: offering.grossGift})
        // });
    }

    async getAssociatedOffering() {}

    async cancel() {
        this.result.next({ success: true });
    }
}
